import TagManager from "react-gtm-module";
import useAuth from "common/hooks/useAuth";

export default function useTracking() {
  const { getCurrentUser } = useAuth();

  const handlePushEvent = (event = "", params = {}, isWithoutUser = false) => {
    const user = getCurrentUser();

    const userParams = {};

    if (Boolean(user) && isWithoutUser === false) {
      Object.keys(user).forEach((keyParam) => {
        const key = `user.${keyParam}`;

        userParams[key] = user[keyParam];
      });
      userParams.userId = user.id;
      userParams.userSalesforceId = user.salesforceId;
      userParams.companySalesforceId = user.companySalesforceId;
    }

    TagManager.dataLayer({
      dataLayer: {
        event,
        ...userParams,
        ...params,
      },
      dataLayerName: "dataLayer",
    });
  };

  return {
    handlePushEvent,
  };
}
